import { getCoupons, onGetSingleCoupon } from 'redux/coupon/sagas/fetchCoupons';
import { onCouponCreate } from 'redux/coupon/sagas/createCoupon';
import { onExportCouponData } from 'redux/coupon/sagas/exportCouponData';
import { call, all } from 'redux-saga/effects';

export default function* couponsSaga() {
  yield all([
    call(getCoupons),
    call(onGetSingleCoupon),
    call(onCouponCreate),
    call(onExportCouponData)
  ]);
}
